<template>
    <el-dialog
        :title="'打印模板选择'"
        :width="'900px'"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="true"
        :before-close="beforeClose"
        :custom-class="'dispatchNewPrintDialog'"
        top="10vh"
    >
        <div class="print-wrapper" v-if="printListLength">
            <el-row>
                <el-col :span="8" v-for="(item, index) in printList" :key="index" class="container">
                    <p class="title">{{ dictData.PRINT_TEMPLATE_STYLE_ATTRIBUTE[item.templateClassification] }}</p>
                    <el-scrollbar class="scrollbar">
                        <div class="templateList">
                            <el-radio-group v-model="item.checkedTemplate">
                                <el-radio
                                    v-for="templateItem in item.templateList"
                                    :key="templateItem.templateCode"
                                    :label="templateItem.templateCode"
                                    @click.native.prevent="handleRadioChange(item, templateItem.templateCode)"
                                    class="radio-item"
                                >
                                {{ templateItem.templateName }}
                                <p
                                    @click.stop.prevent="handlePreview(templateItem.templateCode)"
                                    class="preview-text"> 预览</p>
                                </el-radio>
                            </el-radio-group>
                        </div>
                    </el-scrollbar>
                </el-col>
            </el-row>
        </div>
        <div class="text-container" v-else>
            <p>提示：当前发车单没有匹配的打印模板，请跳转到老版打印界面进行打印或联系城配IT产品经理进行配置。</p>
        </div>
        <div class="new-printf-tip">
            <i class="el-icon-warning tip-icon"></i>
            {{ dictData.NEW_PRINTF_TIP_TEXT.data }}
            <span @click="jumpToUrl" v-if="urlShow">{{ dictData.NEW_PRINTF_TIP_URL.data }}</span>
        </div>
        <div slot="footer" class="print-dialog-footer">
            <el-row :gutter="20">
                <el-col :span="8" style="text-align: left;">
                    <el-checkbox v-model="isRemember" class="checkbox">记住我的选择</el-checkbox>
                    <el-button type="primary" @click="openOldPrintDialog" class="back-to">跳转到老版打印界面</el-button>
                </el-col>
                <el-col :span="8">
                    <div class="printf-input-customer" v-if="!isWaybillManage">
                        <p>以客户订单号打印</p>
                        <el-input placeholder="多个客户订单号，以逗号或空格隔开" v-model="customerOrderNo" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="8" :offset="!isWaybillManage ? 0 : 8">
                    <el-button @click="beforeClose">取 消</el-button>
                    <el-button type="primary" @click="openPrintLog">打印日志</el-button>
                    <el-button type="primary" @click="printBtn" :disabled="!printListLength" :loading="btnLoading">打 印</el-button>
                </el-col>
            </el-row>
        </div>

        <dispatch-print-log
            v-if="isShowPrintLogDialog"
            ref="dispatchPrintLog"
            :isShowPrintLogDialog.sync="isShowPrintLogDialog"
            :componentsData="componentsData"
        ></dispatch-print-log>

        <dispatch-repeat-print
            v-if="isShowPrintReasonDialog"
            ref="dispatchRepeatPrint"
            :isShowPrintReasonDialog.sync="isShowPrintReasonDialog"
            :componentsData="componentsData"
            :tooltip="tooltip"
            @handlePrint="handlePrint"
        ></dispatch-repeat-print>
    </el-dialog>
</template>

<script>
import DispatchPrintLog from '../../dispatchMgmt/components/dispatchPrintLog/Index';
import DispatchRepeatPrint from '../../dispatchMgmt/components/dispatchRepeatPrint/Index.vue';
import { getLocalStorage, setLocalStorage, handleDispatchPrint, checkedDataValidated, searchFieldSeperated } from './util.js';
import { checkPrintCount } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
import bigDataLog from '@/utils/bigDataLog';
import _ from 'lodash';
export default {
    name: 'DispatchNewPrintDialog',
    components: { DispatchPrintLog, DispatchRepeatPrint },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        printConfig: {
            type: Array,
            default () {
                return [];
            }
        },
        isWaybillManage: {
            type: Boolean,
            default () {
                return false;
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        },
        professionalCompanyConfig: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            printList: [],
            customerOrderNo: '',
            isCheckAll: false,
            isRemember: true,
            visible: false,
            btnLoading: false,
            timeOutFlag: false,
            isIndeterminate: false,
            isShowPrintLogDialog: false,
            isShowPrintReasonDialog: false,
            currentTemplateCode: '',
            checkedTemplateList: [],
            isCloseDialog: false, // 打印后是否关闭弹窗，批量打印后关闭，预览不关闭
            tooltip: '',
            CPLimit: false,
            LDLimit: false
        };
    },
    computed: {
        printListLength () {
            return this.printList.length;
        },
        urlShow () {
            return this.dictData.NEW_PRINTF_TIP_URL && this.dictData.NEW_PRINTF_TIP_URL.data;
        }
    },
    async mounted () {
        await this.getRememberFlag();
        this.printList = _.cloneDeep(this.printConfig);
        this.initRadioStatus();
        this.CPLimit = this.professionalCompanyConfig.printCompanyConfig || false;
        this.LDLimit = this.professionalCompanyConfig.printLclConfig || false;
        this.visible = true;
    },
    methods: {
        // 从缓存中读取 记住我的选择 状态
        getRememberFlag () {
            this.isRemember = getLocalStorage('isRemember');
        },
        initRadioStatus () {
            if (!this.printList.length) return;
            this.printList.forEach(item => this.$set(item, 'checkedTemplate', []));
            if (this.isRemember) {
                const storagePrintTemplate = getLocalStorage('printTemplate');
                this.printList.forEach(currentPrintType => {
                    const storagePrintType = storagePrintTemplate.find(storageItem => storageItem.styleAttributeCode === currentPrintType.styleAttributeCode);
                    if (storagePrintType) {
                        const storagePrintTemplate = currentPrintType.templateList.find(templateItem => templateItem.templateCode === storagePrintType.checkedTemplate);
                        if (storagePrintTemplate) {
                            currentPrintType.checkedTemplate = storagePrintType.checkedTemplate;
                        }
                    }
                });
            }
        },
        handleRadioChange (item, currentTemplateCode) {
            this.printList.forEach(v => {
                v.checkedTemplate = '';
            });
            if (item.checkedTemplate !== currentTemplateCode) {
                item.checkedTemplate = currentTemplateCode;
            }
        },

        // 跳转到老版打印界面
        openOldPrintDialog () {
            this.$emit('openOldPrintDialog', this.componentsData);
        },
        jumpToUrl () {
            window.open(this.dictData.NEW_PRINTF_TIP_URL.data);
        },
        // 预览
        handlePreview (templateCode) {
            this.currentTemplateCode = templateCode;
            this.isCloseDialog = false;
            this.checkPrint(this.currentTemplateCode);
        },
        // 批量打印
        printBtn () {
            const isValidated = checkedDataValidated(this.printList);
            if (!isValidated) return;this.checkedTemplateList = this.printList.filter(v => v.checkedTemplate).map(v => v.checkedTemplate).filter(item => item.length);
            this.isCloseDialog = true;
            this.checkPrint(this.checkedTemplateList[0]);
        },
        // 打印校验
        checkPrint (templateCode) {
            checkPrintCount({ dispatchNo: this.componentsData.dispatchNo, templateCode })
                .then(res => {
                    if (res && +res.code === 0) {
                        if (res.data) {
                            this.handlePrint();
                        } else if (this.validateProfessionalCompany()) {
                            this.isShowPrintReasonDialog = true;
                        } else {
                            this.handlePrint();
                        }
                    } else {
                        this.handlePrint();
                    }
                }).catch(() => {});
        },
        // 专司卡控
        validateProfessionalCompany () {
            const professionalCompany = this.componentsData.professionalCompany;
            this.tooltip = '';
            if (this.CPLimit && this.LDLimit) {
                // 城配开启，零担开启，含有城配/零担都需要备注（城配、零担、城配+其他、零担+其他、城配+零担）
                return professionalCompany && (professionalCompany.includes('城配') || professionalCompany.includes('零担'));
            } else if (this.CPLimit && !this.LDLimit) {
                // 城配开启，零担关闭，含有城配都需要备注（城配、城配+零担、城配+其他）
                if (professionalCompany.includes('城配') && professionalCompany.includes('零担')) {
                    this.tooltip = '因城配送装专司对单据补打管控，本发车单含有城配单据，请您选择补打原因';
                }
                return professionalCompany && professionalCompany.includes('城配');
            } else if (!this.CPLimit && this.LDLimit) {
                // 城配关闭，零担开启，含有零担都需要备注（零担、零担+其他、城配+零担）
                if (professionalCompany.includes('城配') && professionalCompany.includes('零担')) {
                    this.tooltip = '因基地干线专司对单据补打管控，本发车单含有基地单据，请您选择补打原因';
                }
                return professionalCompany && professionalCompany.includes('零担');
            } else {
                // 城配关闭，零担关闭，所有专司都不需要备注
                return false;
            }
        },
        // 批量打印
        handlePrint (data, repeatPrintReason) {
            this.handleStorage();
            const params = {
                templateCodeList: this.isCloseDialog ? this.checkedTemplateList : [this.currentTemplateCode],
                dispatchNo: this.componentsData.dispatchNo,
                // taskNoList: this.isWaybillManage ? this.componentsData.taskNoList : [],
                customerOrderNoList: this.isWaybillManage ? this.componentsData.customerOrderNos : searchFieldSeperated(this.customerOrderNo || '')
            };
            if (repeatPrintReason && Object.keys(repeatPrintReason).length) {
                params.reason = repeatPrintReason.reason || '';
                params.remark = repeatPrintReason.remark || '';
            }
            handleDispatchPrint(this, params, this.isCloseDialog); // 处理打印逻辑
        },
        // 缓存逻辑处理
        handleStorage () {
            setLocalStorage('isRemember', this.isRemember);
            if (!this.isRemember) return;
            const storagePrintObject = this.printList.filter(v => Boolean(v.checkedTemplate)).map((item) => {
                return {
                    styleAttributeCode: item.styleAttributeCode,
                    styleAttributeName: item.styleAttributeName,
                    checkedTemplate: item.checkedTemplate
                };
            });
            setLocalStorage('printTemplate', storagePrintObject);
        },
        openPrintLog () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print-log');
            this.isShowPrintLogDialog = true;
        },
        beforeClose () {
            this.$emit('update:isShowNewPrintDialog', false);
        }
    }
};
</script>

<style lang="less">
.dispatchNewPrintDialog {
    .text-container {
        // text-align: center;
        font-size: 13px;
        color: red;
    }
    .new-printf-tip {
        padding: 8px 15px 3px;
        border-radius: 5px;
        line-height: 25px;
        background-color: #EBEEF5;
        justify-content: center;
        .tip-icon {
            margin-right: 10px;
            font-size: 15px;
            color: #00BCBF;
        }
        span {
            cursor: pointer;
            text-decoration: underline;
        }
    }
    .title {
        display: inline-block;
        // color: #00BCBF;
        // border-bottom: 1px solid #EBEEF5;
        font-size: 14px;
        margin: 0px 0px 5px 5px;
        padding-bottom: 2px;
        // padding: 0px 5px 3px 5px;
    }
    .container {
        padding-right: 10px;
    }
    .templateList{
        padding-left: 5px;
    }
    .scrollbar{
        height: 120px;
        margin-bottom: 20px;
    }
    .is-horizontal {
        display: block;
    }
    /* 不展示水平滚动条 */
    /deep/ .is-horizontal {
        display: none;
    }
    .el-radio-group {
        width: 100%;
    }
    .radio-item {
        display: block;
        line-height: 24px;
        .preview-text{
            display: inline-block;
            // color: rgb(255, 199, 0);
            font-weight: 900;
            margin: 0px 0px 0px 6px;
        }
    }
    .radio-item .el-radio__inner {
        border-radius: 0px;
    }
    // 单选按钮实现对勾样式
    .radio-item .el-radio__input.is-checked .el-radio__inner::after {
        content: '';
        width: 8px;
        height: 3px;
        border: 2px solid white;
        border-top: transparent;
        border-right: transparent;
        text-align: center;
        display: block;
        position: absolute;
        top: 2px;
        left: 1px;
        transform: rotate(-45deg);
        border-radius: 0px;
        background: none;
    }
    .el-dialog__body {
        min-height: 100px;
        max-height: 500px;
        overflow: auto;
    }
    .print-dialog-footer {
        .el-row {
            line-height: 40px;
        }
        .checkbox {
            margin-right: 12px;
        }
        .printf-input-customer {
            p {
                display: inline-block;
                font-size: 12px;
                margin: 0 10px 0 0;
            }
            .el-input {
                width: 160px;
            }
        }
    }
}
</style>
